/* eslint-disable no-useless-escape */
/* eslint-disable prettier/prettier */
import Card, { CardProps } from '@mui/material/Card';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

interface LoadingCardProps extends React.PropsWithChildren<CardProps> {
  'data-testid'?: string;
  className?: string;
}

const LoadingCard = (cardProps: LoadingCardProps) => {
  return (
    <Card {...cardProps} style={{ textAlign: 'center' }}>
      <CircularProgress />
    </Card>
  );
};

export default LoadingCard;
